function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { TransitionHookError } from '../common/transition-hooks/errors';
import { ActionType } from '../common/transition-hooks/ActionType';
var _router = /*#__PURE__*/new WeakMap();
var _transitionHooksPlugin = /*#__PURE__*/new WeakMap();
var _errorHandler = /*#__PURE__*/new WeakMap();
var _logger = /*#__PURE__*/new WeakMap();
var TransitionHooksExecutor = /*#__PURE__*/function () {
  function TransitionHooksExecutor(router, pluginManager, errorHandler) {
    var logger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.console;
    _classCallCheck(this, TransitionHooksExecutor);
    _classPrivateFieldInitSpec(this, _router, void 0);
    _classPrivateFieldInitSpec(this, _transitionHooksPlugin, void 0);
    _classPrivateFieldInitSpec(this, _errorHandler, void 0);
    _classPrivateFieldInitSpec(this, _logger, void 0);
    _classPrivateFieldSet(_router, this, router);
    _classPrivateFieldSet(_transitionHooksPlugin, this, pluginManager.getTransitionHooksPlugin());
    _classPrivateFieldSet(_errorHandler, this, errorHandler);
    _classPrivateFieldSet(_logger, this, logger);
  }
  return _createClass(TransitionHooksExecutor, [{
    key: "shouldNavigate",
    value: function shouldNavigate(url) {
      var _this = this;
      var route = _classPrivateFieldGet(_router, this).match(url);
      // This code is executed before the router change, so current = previous
      var prevRoute = _classPrivateFieldGet(_router, this).getCurrentRoute();
      if (route.specialRole !== null) {
        return true;
      }
      var hooks = _classPrivateFieldGet(_transitionHooksPlugin, this).getTransitionHooks();
      if (hooks.length === 0) {
        return true;
      }
      var _loop = function _loop() {
          var hook = hooks[_i2];
          try {
            var action = hook({
              route: {
                meta: route.meta,
                url: route.reqUrl,
                hostname: window.location.host,
                route: route.route
              },
              prevRoute: {
                meta: prevRoute.meta,
                url: prevRoute.reqUrl,
                hostname: window.location.host,
                route: route.route
              },
              navigate: _classPrivateFieldGet(_router, _this).navigateToUrl
            });
            if (action.type === ActionType.stopNavigation) {
              _classPrivateFieldGet(_logger, _this).info("ILC: Stopped navigation due to the Route Guard with index #".concat(hooks.indexOf(hook)));
              return {
                v: false
              };
            }
            if (action.type === ActionType.redirect) {
              // Need to add redirect callback to queued tasks
              // because it should be executed after micro tasks that can be added after the end of this method
              setTimeout(function () {
                _classPrivateFieldGet(_logger, _this).info("ILC: Redirect from \"".concat(route.reqUrl, "\" to \"").concat(action.newLocation, "\" due to the Transition Hook with index #").concat(hooks.indexOf(hook)));
                _classPrivateFieldGet(_router, _this).navigateToUrl(action.newLocation);
              });
              return {
                v: false
              };
            }
          } catch (error) {
            var hookIndex = hooks.indexOf(hook);
            _classPrivateFieldGet(_errorHandler, _this).call(_this, new TransitionHookError({
              message: "An error has occurred while executing \"".concat(hookIndex, "\" transition hook for the following URL: \"").concat(url, "\"."),
              data: {
                hookIndex: hookIndex,
                url: url
              },
              cause: error
            }));
            return {
              v: false
            };
          }
        },
        _ret;
      for (var _i2 = 0; _i2 < hooks.length; _i2++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      } // If none of the hooks returned "redirect" or "stop-navigation" action
      return true;
    }
  }]);
}();
export { TransitionHooksExecutor as default };